<template>
	<div id="standardIndex">
		<!-- 在离线统计 -->
		<div
			id="offline"
			ref="offline"
			style="
				width: calc((100% - 24px) / 3);
				height: 350px;
				margin: 0 24px 24px 0;
			"
		>
			在离线统计
		</div>
		<!-- 设备新增趋势 -->
		<div
			id="newTrend"
			style="
				width: calc((100% - 24px) / 3 * 2);
				height: 350px;
				margin-bottom: 24px;
			"
		>
			<div class="radio">
				<el-radio-group
					v-model.trim="timeBlock"
					size="small"
					@change="getTendency"
				>
					<el-radio-button label="1">24时</el-radio-button>
					<el-radio-button label="2">月</el-radio-button>
					<el-radio-button label="3">年</el-radio-button>
				</el-radio-group>
				<el-select
					class="marginL20"
					v-model.trim="brand"
					size="small"
					@change="getTendency"
					clearable
					placeholder="品牌"
				>
					<el-option
						v-for="item in brands"
						:key="item.value"
						:value="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</div>
			<div ref="newTrend" style="width: 100%; height: 100%"></div>
		</div>
		<!-- 产品类型统计 -->
		<div
			id="category"
			ref="category"
			style="
				width: calc((100% - 24px) / 3);
				height: 52%;
				margin-right: 24px;
			"
		>
			产品类型统计
		</div>
		<div
			id="model"
			style="
				width: calc((100% - 24px) / 3);
				height: 52%;
				margin-right: 24px;
			"
		>
			<div class="select">
				<el-select
					clearable
					v-model.trim="productTypeForm.productTypeId"
					@change="getPMStatistics"
				>
					<el-option
						v-for="item in productTypes"
						:key="item.id"
						:label="item.productType"
						:value="item.id"
					></el-option>
				</el-select>
				<el-select
					clearable
					class="marginT10"
					v-model.trim="productTypeForm.brand"
					size="small"
					@change="getPMStatistics"
				>
					<el-option
						v-for="item in brands"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					></el-option>
				</el-select>
			</div>
			<div ref="model" style="width: 100%; height: 100%"></div>
		</div>
		<!-- 设备分布 -->
		<div
			id="spread"
			ref="spread"
			style="width: calc((100% - 96px) / 3); height: 52%"
		>
			设备分布
		</div>
	</div>
</template>

<script>
import indexEcharts from "@/libs/indexEcharts";
export default {
	data() {
		return {
			offline: {},
			productTypes: [],
			value: "智能烹饪机",
			productTypeForm: {
				productTypeId: null,
				brand: null,
			},
			timeBlock: "1",
			brand: this.$store.state.standard.brands[0].value,
			brands: this.$store.state.standard.brands,
			modelData: {
				title: "产品型号统计",
				subtext: "总数(台)",
				total: "",
				tip: "{b} {c}台 ({d}%)",
				name: [],
				value: [],
			},
			newTrendData: {
				title: "设备新增趋势",
				subtext: "总数(台)",
				type: "line",
				sname: "2019-6-2",
				tal: "9999",
				tip: "{b}\n 新增设备：{c}",
				name: [],
				value: [],
			},
			category: {
				title: "产品类型统计",
				subtext: "总数(台)",
				total: "",
				tip: "{b}\n {c}台 ({d}%)",
				name: [],
				value: [],
				total: "",
			},
			spread: {
				name: [],
				value: [],
				total: "",
				barValue: [],
				barData: [],
			},
		};
	},
	mounted() {
		this.indexEcharts();
		this.getTendency();
		this.getPMStatistics();
		this.getDeviceDistribution();
		this.getProductTypesAll();
		this.getPTStatistics();
		const that = this;
		window.onresize = () => {
			return (() => {
				this.$echarts.init(that.$refs.offline).resize();
				this.$echarts.init(that.$refs.newTrend).resize();
				this.$echarts.init(that.$refs.category).resize();
				this.$echarts.init(that.$refs.model).resize();
				this.$echarts.init(that.$refs.spread).resize();
			})();
		};
	},
	methods: {
		// 获取所有产品类型
		getProductTypesAll: function () {
			this.$http.productTypesAll().then((res) => {
				this.productTypes = res.data.data;
			});
		},
		// 获取各类统计数据
		indexEcharts() {
			// 设备在离线
			this.$http.devicesOnlineNum().then((res) => {
				if (res.data && res.data.success) {
					this.offline = res.data.data;
					indexEcharts.offline(this.$refs.offline, this.offline);
				}
			});
		},
		// 获取设备新增趋势
		getTendency: function () {
			let para = {
				brand: this.brand,
				type: this.timeBlock,
			};
			this.$http.standardDeviceTendency(para).then((res) => {
				if (res.data && res.data.success) {
					this.newTrendData.name = [];
					this.newTrendData.value = [];
					res.data.data.forEach((item) => {
						this.newTrendData.name.push(item[0]);
						this.newTrendData.value.push(item[1]);
					});
					indexEcharts.newTrend(
						this.$refs.newTrend,
						this.newTrendData
					);
				}
			});
		},
		// 获取设备分布
		getDeviceDistribution: function () {
			this.$http.standardDeviceDistribution().then((res) => {
				if (res.data && res.data.success) {
					let list = Object.assign([], res.data.data);
					this.spread.name = [];
					this.spread.value = [];
					for (let i in list) {
						this.spread.name.push(i);
						this.spread.barValue.push(list[i]);
						this.spread.value.push({
							name: i,
							value: list[i],
						});
						this.spread.barData.push(this.offline.total);
					}
					this.spread.total = this.offline.total;
					indexEcharts.spread(this.$refs.spread, this.spread);
				}
			});
		},
		// 产品型号统计
		getPMStatistics: function () {
			this.$http.pMStatistics(this.productTypeForm).then((res) => {
				if (res.data && res.data.success) {
					let list = Object.assign([], res.data.data),
						total = 0;
					this.modelData.name = [];
					this.modelData.value = [];
					for (let i in list) {
						this.modelData.name.push(i);
						this.modelData.value.push({
							name: i,
							value: list[i],
						});
						total = total + Number(list[i]);
					}
					this.modelData.total = total;
					indexEcharts.model(this.$refs.model, this.modelData);
				}
			});
		},
		// 产品类型统计
		getPTStatistics() {
			this.$http.pTStatistics().then((res) => {
				if (res.data && res.data.success) {
					let list = Object.assign([], res.data.data),
						total = 0;
					this.category.name = [];
					this.category.value = [];
					for (let i in list) {
						this.category.name.push(i);
						this.category.value.push({
							name: i,
							value: list[i],
						});
						total = total + Number(list[i]);
					}
					this.category.total = total;
					indexEcharts.model(this.$refs.category, this.category);
				}
			});
		},
	},
	destroyed() {
		window.onresize = null;
	},
};
</script>

<style lang="less">
#standardIndex {
	float: left;
	overflow-y: auto;
	overflow-x: hidden;
	height: 100%;
	width: 100%;
	min-height: 660px;
	> div {
		border-radius: 4px;
		background: #fff;
		box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.05);
		float: left;
	}
	#model {
		position: relative;
		> p {
			float: left;
			padding: 24px 0 0 24px;
			font-size: 14px;
			color: #59626c;
			font-weight: bold;
		}
		> .select {
			height: 24px;
			top: 24px;
			right: 14px;
			width: 150px;
			position: absolute;
			z-index: 1;
			.el-input__icon {
				line-height: 24px;
			}
			input.el-input__inner {
				height: 24px;
			}
		}
	}
	#newTrend {
		position: relative;
		> .radio {
			top: 24px;
			right: 30px;
			position: absolute;
			z-index: 1;
			.el-radio-button__orig-radio:checked + .el-radio-button__inner {
				background-color: #f02b54;
				border-color: #f02b54;
				box-shadow: -1px 0 0 0 #f02b54;
				color: #fff;
			}
			.el-radio-button__inner:hover {
				color: #f02b54;
			}
		}
	}
}
</style>
